import { Chips, Separator, Slider } from 'platform/components';
import { HStack, VStack } from 'platform/foundation-tw';
import { useState } from 'react';
import { isNumber, isString } from 'ramda-adjunct';
import { suffixTestId } from 'shared/web';
import { useFilterOnChipsChange } from '../../hooks/useFilterOnChipsChange';
import { useSliderTicks } from '../../hooks/useSliderTicks';
import { EagFilterProps } from '../../types/EagFilterProps';
export type SliderFilterProps = EagFilterProps & {
  min: number;
  max: number;
  minOpen: boolean;
  maxOpen: boolean;
  unit: string | null;
  stepSize: number | null;
  steps: number[];
  markerSize: number | null;
  markers?: number[];
  decimalsAllowed: boolean;
  inputsVisible: boolean;
  quickFilters?: Array<{
    value: string;
    label: string;
  }>;
};
const FILTER_VALUE_KEY = 'value';
export function SliderFilter(props: SliderFilterProps) {
  const ticks = useSliderTicks(props.min, props.max, props.markerSize, props.markers);
  const midValue = (props.max + props.min) / 2;
  const model = props.value[FILTER_VALUE_KEY] as number | string | null;
  const onModelChange = (newValue: number | string | null) => {
    props.onChange({
      [FILTER_VALUE_KEY]: newValue
    });
  };
  const {
    onChipsChange
  } = useFilterOnChipsChange({
    setFilterValue: onModelChange,
    defaultValue: null
  });
  const valueFormatter = (value: number) => props.unit ? `${value} [${props.unit}]` : `${value}`;
  const isQuickFilterValue = isString(model) ? [model] : null;
  const [localSliderValue, setLocalSliderValue] = useState<number>(isNumber(model) ? model : midValue);
  const onSliderValueChange = (value: number) => {
    setLocalSliderValue(value);
    onModelChange(value);
  };
  return <VStack>
      {props.quickFilters && props.quickFilters.length > 0 && <>
          <HStack>
            <Chips isDisabled={props.isDisabled} value={isQuickFilterValue} options={props.quickFilters} onChange={onChipsChange} isMultiple={false} data-testid={suffixTestId('slider-filter-quickFilters', props)} isDeselectable />
          </HStack>
          <Separator />
        </>}
      <Slider isDisabled={props.isDisabled} min={props.min} max={props.max} step={props.stepSize ?? props.steps ?? 1} value={localSliderValue} onChange={onSliderValueChange} formatValue={valueFormatter} ticks={ticks} onlyEdges={true} displayValue="auto" data-testid={suffixTestId('slider-filter', props)} />
    </VStack>;
}